<template>
  <div class="profile">
    <Hero title="" :image="'banner-hero-1.jpg'" :search="true" height="60vh" />

    <div class="content">
      <div class="container">
        <div class="row pb-5">
          <div class="col-12 col-lg-12 mx-auto mt-n5">
            <div class="row">
              <div class="col-md-2">
                <ProfileSidebarMenu
                  personalData
                  education
                  professionalExp
                  language
                  subscriptions
                />
              </div>

              <div class="col-12 col-md-10">
                <div class="position-relative">
                  <LoaderContent
                    v-if="!graphql_loaded"
                    :welcomeMessage="false"
                    :alignSpinnerTop="true"
                  />
                  <div v-else>
                    <BoxPersonalData
                      ref="box-personal-data"
                      format="inline-form"
                      style="border-radius: 4px"
                      id="box-personal-data"
                      class="bg-white shadow p-4 p-md-5"
                    />

                    <div class="my-4 border-bottom border-dark"></div>

                    <BoxEducation
                      ref="box-education"
                      format="inline-form"
                      style="border-radius: 4px"
                      id="box-education"
                      class="bg-white shadow p-4 p-md-5"
                    />

                    <div class="my-4 border-bottom border-dark"></div>

                    <BoxProfessionalExp
                      ref="box-professional-experience"
                      format="inline-form"
                      style="border-radius: 4px"
                      id="box-professional-experience"
                      class="bg-white shadow p-4 p-md-5"
                    />

                    <div class="my-4 border-bottom border-dark"></div>

                    <BoxLanguage
                      ref="box-language"
                      format="inline-form"
                      style="border-radius: 4px"
                      id="box-language"
                      class="bg-white shadow p-4 p-md-5"
                    />

                    <div class="my-4 border-bottom border-dark"></div>

                    <BoxSubscriptions
                      ref="box-subscription"
                      format="inline-form"
                      style="border-radius: 4px"
                      id="box-subscription"
                      class="bg-white shadow p-4 p-md-5"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import LoaderContent from "ninenine-white-label/src/components/Loader/LoaderContent.vue";
import EllipsisLoader from "ninenine-white-label/src/components/Loader/EllipsisLoader.vue";
import BoxPersonalData from "ninenine-white-label/src/components/PersonalData/BoxPersonalData.vue";
import BoxEducation from "ninenine-white-label/src/components/Education/BoxEducation.vue";
import BoxProfessionalExp from "ninenine-white-label/src/components/ProfessionalExp/BoxProfessionalExp.vue";
import BoxLanguage from "ninenine-white-label/src/components/Language/BoxLanguage.vue";
import BoxSubscriptions from "ninenine-white-label/src/components/Subscriptions/BoxSubscriptions.vue";
import ProfileSidebarMenu from "@/components/subscription/ProfileSidebarMenu.vue";

export default {
  name: "RegisterProfile",

  data() {
    return {
      graphql_loaded: false,
      isSaving: false,
    };
  },

  head() {
    return this.$head({
      title: "",
    });
  },

  components: {
    Hero,
    LoaderContent,
    EllipsisLoader,
    BoxPersonalData,
    BoxEducation,
    BoxProfessionalExp,
    BoxLanguage,
    BoxSubscriptions,
    ProfileSidebarMenu,
  },

  mounted() {
    setTimeout(() => this.removeAutoFillSelectize(), 500);
    this.getProfile();
  },

  methods: {
    scroll() {
      window.scroll(0, 1);
    },

    getProfile() {
      let requestDomainReturn = "";

      if (this.$store.state.domains.countries.length == 0) {
        requestDomainReturn += `countries { id, name },`;
      }
      if (this.$store.state.domains.genders.length == 0) {
        requestDomainReturn += `genders { id, description },`;
      }
      if (this.$store.state.domains.maritalStatus.length == 0) {
        requestDomainReturn += `maritalStatus {id, description},`;
      }
      if (this.$store.state.domains.states.length == 0) {
        requestDomainReturn += `states { id, name, abbr },`;
      }
      if (this.$store.state.domains.disabilities.length == 0) {
        requestDomainReturn += `disabilities { id, name },`;
      }
      if (this.$store.state.domains.education_levels.length == 0) {
        requestDomainReturn += `educationLevels {id, description},`;
      }
      if (this.$store.state.domains.education_status.length == 0) {
        requestDomainReturn += `educationStatus {id, description},`;
      }
      if (this.$store.state.domains.companies.length == 0) {
        requestDomainReturn += `companies {id, name},`;
      }
      if (this.$store.state.domains.professional_experience_areas.length == 0) {
        requestDomainReturn += `professionalExperienceAreas {id, name},`;
      }
      if (
        this.$store.state.domains.professional_experience_levels.length == 0
      ) {
        requestDomainReturn += `professionalExperienceLevels {id, name}`;
      }
      if (this.$store.state.domains.languages.length == 0) {
        requestDomainReturn += `languages {id, name},`;
      }
      if (this.$store.state.domains.language_proficiencies.length == 0) {
        requestDomainReturn += `languageProficiencies {id, description},`;
      }

      if (requestDomainReturn.length > 0) {
        requestDomainReturn = `domains {
          ${requestDomainReturn}
        },`;
      }

      this.$store
        .dispatch(
          "graphql_queries/query",
          `
        ${requestDomainReturn}
        user( id: "${this.$store.state.user.profile.id}" ){
          avatar,
          profile{
            firstname,
            lastname,
            email,
            nationality,
            cpf,
            passport,
            gender,
            maritalStatus,
            phone,
            birthday,
            whatDoYouLove,

            location {
              zipcode,
              street,
              number,
              complement,
              neighborhood,
              stateId,
              city
            },

            hasDisability,

            disabilities {
              disabilityId,
              name
            },

            educations {
              id,
              institutionName,
              level,
              courseName,
              startDate,
              endDate,
              stateId
            },

            professionalExperiences {
              id,
              role,
              responsabilities,
              company,
              startYear,
              endYear
            },

            languageProficiencies {
              id,
              language,
              proficiency
            },

          }
        },
      `
        )
        .then((results) => {
          this.graphql_loaded = true;
          setTimeout(() => this.$EventBus.$emit("editingPersonalData"), 100);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.profile {
  .content {
    z-index: 990 !important;
    position: relative;
  }
}

/deep/ .form-row {
  h6 {
    font-weight: normal !important;
    color: black !important;
    font-size: 14px !important;
  }

  p,
  input {
    font-weight: bold !important;
  }
}
</style>